
import { TypeFormResponse } from "@/types/bingo";

export const normalizedTypeFormResponse = (
  response: TypeFormResponse
) => {
  const { definition, answers } = response;

  const normalizedAnswers = answers.map((answer) => {
    const questionStr = definition.fields.find(field => field.ref === answer.field.ref)?.title;
    const { answerStr, fileUrl } = (() => {
      if (answer.type === "choice") {
        return { answerStr: answer.choice.label };
      }

      if (answer.type === "email") {
        return { answerStr: answer.email };
      }

      if (answer.type === "text") {
        return { answerStr: answer.text };
      }

      if (answer.type === "file_url") {
        return { fileUrl: answer.file_url };
      }

      return { answerStr: "Unhandled answer type" };
    })();

    return {
      question: questionStr,
      answer: answerStr,
      fileUrl,
    }
  });

  return normalizedAnswers
};

export const getTypeFormUrl = (formId: string) => {
  // Use the new Typeform URL format
  return `https://form.typeform.com/to/${formId}`;
}
